import Utils from "./utils";
import Isotope from "isotope-layout";

class ChantierFilter {

	constructor() {
		Utils.debug('CHANTIER TUILES :: Construct');

		this.$container = $('.grid');

		if (this.$container.length === 0) {
			return;
		}

		this.init();
	}



	init() {
		Utils.debug('CHANTIER TUILES :: init');
		this.iso = new Isotope( ".grid", {
			hiddenStyle: {
				opacity: 0
			},
			visibleStyle: {
				opacity: 1
			},
			// options
			masonry: {
				columnWidth: '.grid-sizer',
				horizontalOrder: true,
				gutter: '.gutter-sizer'
			},
			itemSelector: '.grid-item',
			percentPosition: true
		});

		let self = this;
		$(".expertise").on('click', function () {
			let filterValue = $(this).attr('data-filter');
			self.iso.arrange({
				filter: filterValue
			});
			$(this).addClass('active').siblings().removeClass('active');
		})
	}

}

module.exports = ChantierFilter;
